var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @ts-ignore underscore
import { shuffle } from 'underscore/modules';
import { MINUTE_MS, SECOND_MS } from '../../time';
export var surveySliceName = 'surveySlice';
export var SURVEY_MIN_UPDATE = 5 * MINUTE_MS;
export var SURVEY_FETCH_TIMEOUT = 30 * SECOND_MS;
export function getSurveyOptions(survey) {
    var options = survey.options, additionalOptions = survey.additionalOptions;
    if (!additionalOptions) {
        return options.map(function (option) { return ({ label: option }); });
    }
    return options.map(function (option, i) { return (__assign(__assign({}, additionalOptions[i]), { label: option })); });
}
export function getVotingResults(votingOptions, votingData) {
    if (!votingData) {
        return null;
    }
    return votingOptions.map(function (option) {
        var _a;
        var optionVotingData = ((_a = votingData.options) !== null && _a !== void 0 ? _a : []).find(function (voting) { return voting.value === option.label; });
        return __assign(__assign({}, option), { votingPercent: optionVotingData
                ? (optionVotingData.votes * 100) / votingData.totalVotes
                : 0 });
    });
}
/**
 * Shuffle voting options and decorate the survey object with a comprehensive `votingOptions` field
 * and a `votingResults` that enhances each `votingOption` object with voting data if the voting data is present
 */
export function getDetailedSurvey(survey) {
    if (survey.disabled) {
        return survey;
    }
    var votingOptions = shuffle(getSurveyOptions(survey));
    var votingResults = getVotingResults(votingOptions, survey.votes);
    return __assign(__assign({}, survey), { votingOptions: votingOptions, votingResults: votingResults });
}
export function getMaxScale(votingResults) {
    var maxValue = Math.max.apply(Math, votingResults.map(function (resultItem) { return resultItem.votingPercent; }));
    return Math.ceil(maxValue / 10) * 10;
}
